export function getConfig() {
  if (process.env.NODE_ENV === "development") {
    return {
      VUE_APP_DEPLOYMENT_ENDPOINT: process.env.VUE_APP_DEPLOYMENT_ENDPOINT,
      VUE_APP_PAYMENT_ENDPOINT: process.env.VUE_APP_PAYMENT_ENDPOINT,
      VUE_APP_ADD_DEV_TERMINAL: process.env.VUE_APP_ADD_DEV_TERMINAL
    };
  }

  return window.config;
}
